import { apiClient } from "./api";

export const getAplicacionesBranding = () => {
  return apiClient.get("/aplicaciones/branding");
};
